import StageApi from './rest/StageApi';

export default new StageApi();
